<template>
  <v-container class="SecurityParameter">
    <v-sheet
      min-height="300"
      rounded="lg"
      elevation="6"
    >
    <v-toolbar class="my-md-auto " elevation="0" rounded="lg">
      <v-toolbar-title  class="hidden-md-and-down">
          <h2><v-icon large>mdi-account-cog</v-icon>{{ $t('administration.securityparameter.securityparameter')}}</h2>
      </v-toolbar-title>
      <v-spacer />
      <div>
        <v-btn
          class="ml-2"

          :to="{ name: 'SecurityParameterList' }"
        >
          {{ $t('global.back')}}
        </v-btn>
        <v-btn
          v-if="userHasAccess('security_parameter_edit')"
          class="ml-2"
          color="primary"
          :to="{ name: 'SecurityParameterUpdate' }"
        >
          {{ $t('global.update')}}
        </v-btn>
      </div>
    </v-toolbar>

    <div  v-if="item">
      <v-row>
        <v-col md="6">
          <v-divider></v-divider>
          <v-row>
            <v-col md="4" >
              <strong class="ml-4">{{ $t('administration.securityparameter.parameter') }}:</strong>
            </v-col>
            <v-col md="8">
              <span class="mr-2">{{ item['name'] }}</span>
            </v-col>
          </v-row>

        </v-col>
        <v-col md="6">
          <v-divider></v-divider>
          <v-row>
            <v-col md="4" >
              <strong class="ml-4">{{ $t('administration.securityparameter.value') }}:</strong>
            </v-col>
            <v-col md="8">
              <span class="mr-2">{{ item['value'] }}</span>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-divider></v-divider>
          <p class="ml-4">{{ $t('administration.securityparameter.' + item['name'] ) }}</p>
        </v-col>
      </v-row>

    </div>
    </v-sheet>
      <Loading :visible="isLoading" />
  </v-container>

</template>


<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import AccessMixin from '../../mixins/AccessMixin';

const servicePrefix = 'SecurityParameter';

export default {
  name: 'SecurityParameterShow',
  servicePrefix,
  components: {
      Loading,
  },
  mixins: [ShowMixin,AccessMixin],
  computed: {
    ...mapFields('securityparameter', {
      isLoading: 'isLoading'
    }),
    ...mapGetters('securityparameter', ['find']),

  },
  methods: {
    ...mapActions('securityparameter', {
      deleteItem: 'del',
      reset: 'reset',
      retrieve: 'load'
    })
  }
};
</script>
